import { format } from 'date-fns';

import { UnitMethodData } from '../../../components/unit/unit-method';
import { PaymentTreatment } from '../../../types';
import { PriceVariant, PriceVariantDateStr } from '../../../components/unit/types';

/**
 * Returns price variants with updated `start_date` and `end_date` fields to string as backend is expecting strings for those 2 fields
 * @param priceVariants Price variant list
 * @returns price variants where start_date and end_date are updated to `string`
 */
export const getPriceVariantsWithStrDate = (priceVariants: PriceVariant[]): PriceVariantDateStr[] =>
  priceVariants.map(price_variant => ({
    ...price_variant,
    start_date: format(price_variant.start_date, 'yyyy-MM-dd'),
    end_date: price_variant.end_date ? format(price_variant.end_date, 'yyyy-MM-dd') : null
  }));
/**
 * Get unit assumption content for preview route
 */
export const getUnitMethodData = (argObj: {
  predictionName: string;
  vatPercentage: string;
  unitMethodData: UnitMethodData;
  accountIndex: string;
  paymentTreatment: PaymentTreatment;
}) => {
  const { predictionName, vatPercentage, unitMethodData, accountIndex, paymentTreatment } = argObj;
  const data = {
    ...unitMethodData,
    price_variants: getPriceVariantsWithStrDate(unitMethodData.price_variants),
    name: predictionName,
    vat_percentage: paymentTreatment === PaymentTreatment.NON_CASH_TRANSFER ? '0' : vatPercentage || null,
    account_id: accountIndex,
    excluded_from_report: false,
    amount: '0',
    invoice_date: null
  };

  return data;
};
